import type {BaseThreejsCameraObjNodeType} from '../../_BaseCamera';

export function PARAM_CALLBACK_reset_effects_composer(node: BaseThreejsCameraObjNodeType) {
	node.postProcessController().reset();
}
